export enum Routes {
    ABOUT = '/about',
    COMING_SOON = '/coming-soon',
    CONTACT_US = '/contact-us',
    PRIVACY_POLICY = '/privacy-policy',
}
